<template>
   <div class="videos-page">
     <div class="header">
        <span>{{ name }}</span>
        <span v-if="total !== ''">(当前在线人数：{{ total }})</span>
     </div>
     <div class="container" ref="contentV" @scroll="videoScroll($event)">
        <ExamItem v-for="item in list" :item="item" :key="item.id" class="examinee"></ExamItem>
     </div>
   </div>
</template>
<script>
import ExamItem from './components/videoItem.vue'
export default {
   name: '',
   components: {
     ExamItem,
   },
   mixins: [],
   props: {
     
   },
   data() {
     return {
       list: [],
       total: '',
       page: 1,
       limit: 30,
       scrollRequest: false,
       name: '',
     }
   },
   computed: {
     
   },
   watch: {
     
   },
   mounted() {
     this.getListFunc();
   },
   methods: {
     videoScroll() {
        if(this.scrollRequest){
            return false;
        }
        let scrollHeight = this.$refs.contentV.scrollHeight;
        let clientHeight = this.$refs.contentV.clientHeight;
        let scrollTop = this.$refs.contentV.scrollTop;
        if(scrollHeight - (scrollTop+clientHeight) <= 1 ){
            if(this.list.length >= this.total){
                return false;
            }else{
                this.scrollRequest = true;
                this.page += 1;
                this.getListFunc();
            }
        }
     },
     getListFunc(){
        this.$http.get('/api/exam/getExamAffairUserList', {
            page: this.page,
            limit: this.limit,
            exam_affair_id: this.$route.query.id,
        }).then(res => {
            this.name = res.name||''
            if(res.list){
                if(this.page === 1){
                    this.list = res.list
                }else{
                    this.list = this.list.concat(res.list)
                }
                this.total = res.total
            }
            this.scrollRequest = false;
        })
     }
   }
};
</script>
<style lang='scss' scoped>
.videos-page{
    width: 100%;
    height: 100vh;
    background-color: #2a2a2a;
    color: #fff;
    box-sizing: border-box;
}
.header{
    flex-shrink: 0;
    width: 100%;
    height: 40px;
    padding: 8px 16px 8px 24px;
    line-height: 40px;
    font-size: 16px;
    font-weight: 500;
}
.container{
    border-color: #000;
    border-width: 2px 0px 0 0px;
    border-style: solid;
    width: 100%;
    height: calc(100vh - 58px);
    overflow-y: auto;
    display: flex;
    flex-wrap: wrap;
    align-content: start;
    padding: 1px;
    .examinee{
        position: relative;
        width: 320px;
        height: 180px;
        border: 1px solid black;
        background-color: #2a2a2a;
        cursor: pointer;
        box-sizing: border-box;
    }
}
</style>